import { useLang } from "@/lib/i18n";

export default function Marquee() {
  const { t } = useLang();
  const ITEMS = t("marquee.items");
  const row = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="marquee-section" className="border-y border-black bg-[#F4F4F1] py-5 overflow-hidden" aria-label="Capabilities">
      <div className="animate-marquee flex w-max items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center font-mono text-sm tracking-[0.25em] text-muted-foreground uppercase whitespace-nowrap">
            <span className="px-10">{item}</span>
            <span className="text-primary">//</span>
          </span>
        ))}
      </div>
    </section>
  );
}
